import React, { useState, useEffect } from "react";
import "../../assets/css/views/schedulingAgendas/schedulingAgendas.css";
import { useTranslation } from "react-i18next";
import {
  Select,
  Button,
  IconDocumentCopy,
  Stepper,
  Table,
  TableData,
  TableColumns,
  TablePreferences,
  TableColumnWidth,
  SelectOption,
  ContextualMenu,
  IconPencil,
  IconTrash,
  Modal,
  ButtonGroup,
  DateRange,
  IconWarningAlt,
  OptionInterface,
  Card,
  Search,
} from "@veneer/core";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";

//Datepicker

import { createTheme } from "@mui/material/styles";

import appointmentService from "../../services/agendaApi/appointment.service";

import { ITypeOfAppointmentDto } from "../../models/dto/agendaApi/ITypeOfAppointmentDto";
import { ISubretailDto } from "../../models/dto/agendaApi/ISubretailDto";
import {
  IPointOfSaleByCoordinatesDto,
  IPointOfSaleByListDto,
} from "../../models/dto/agendaApi/IPointOfSaleDto";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { decryptText } from "../../utils/encryptionUtils";
import AgendaManagement from "../../services/agendaApi/agendaManagement";
import { IGetStateListDto } from "../../models/dto/userManagementApi/IGetStateListDto";
import { IGetCityListDto } from "../../models/dto/userManagementApi/IGetCityListDto";
import { IGetAdviserListDto } from "../../models/dto/agendaApi/IGetAdviserListDto";
import { IGetAppointmentsByUser } from "../../models/dto/agendaApi/IGetAppointmentsByUser";
import { AgendaCreationBlock } from "./AgendasComponent/AgendaCreationBlock";
import { IUpdateAppoiment } from "../../models/input/agendaApi/IUpdateAppoiment";
import { AgendaEditingBLock } from "./AgendasComponent/AgendaEditingBLock";
import { ModalMessageAgenda } from "./AgendasComponent/ModalMessageAgenda";
import useSearchSelect from "../../hooks/searchSelect/useSearchSelect";
const googleMapKey: string | undefined = process.env.REACT_APP_GOOGLE_MAP_KEY;

export default function SchedulingAgendas() {
  const [t] = useTranslation("global");
  const { handleSearch } = useSearchSelect();

  const languageID: any = useSelector((state: RootState) => state.languageId);

  type SelectValue = number | string | boolean; //CHECK

  //Loadings
  const [loadingTableData, setLoadingTableData] = useState(false);

  //Disables
  const [disableAdvisor, setDisableAdvisor] = useState(true);
  const [addAgendaButtonDisable, setAddAgendaButtonDisable] = useState(true);
  const [editAgendaButtonDisable, setEditAgendaButtonDisable] = useState(false);
  const [disableTypeOfVisit, setDisableTypeOfVisit] = useState(true);
  const [disableSubretail, setDisableSubretail] = useState(true);
  const [disablePointOfSale, setDisablePointOfSale] = useState(true);
  const [openAddAgendaDisable, setOpenAddAgendaDisable] = useState(true);
  const state: any = useSelector((state: RootState) => state.user);

  //Data
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [tableFilteredData, setTableFilteredData] = useState<TableData[]>([]);
  const [typeofAppointmentData, setTypeofAppointmentData] = useState<
    SelectOption[]
  >([]);
  const [typeofAppointmentDataCopy, setTypeofAppointmentDataCopy] = useState<
    SelectOption[]
  >([]);
  const [subretailData, setSubretailData] = useState<SelectOption[]>([]);
  const [subretailDataCopy, setSubretailDataCopy] = useState<SelectOption[]>(
    []
  );
  const [pointOfSaleData, setPointOfSaleData] = useState<SelectOption[]>([]);
  const [pointOfSaleDataCopy, setPointOfSaleDataCopy] = useState<
    SelectOption[]
  >([]);
  let tableDataArray: IGetAppointmentsByUser[];
  const [valueState, setValueState] = useState<number[]>([]);
  const [valueCity, setValueCity] = useState<number[]>([]);
  const [valueAdviser, setValueAdviser] = useState<number[]>([]);

  //Errors
  const [errorPos, setErrorPos] = useState<boolean>(false);
  const [errorDatePicker, setErrorDatePicker] = useState<boolean>(false);

  //Valid
  const [isValidCoordinates, setIsValidCoordinates] = useState(false);
  const [isStateValid, setIsStateValid] = useState<boolean>(true);

  //Selects
  const [typeOfVisit, setTypeOfVisit] = useState<SelectValue[]>([]);
  const [typeOfVisitId, setTypeOfVisitId] = useState<number>(NaN);
  const [subRetail, setSubRetail] = useState<SelectValue[]>([]);
  const [pointOfSale, setPointOfSale] = useState<SelectValue[]>([]);
  const [appointmentSelected, setAppointmentSelected] = useState<number>(NaN);
  const [optionsState, setOptionsState] = useState<SelectOption[]>([]);
  const [optionsStateCopy, setOptionsStateCopy] = useState<SelectOption[]>([]);
  const [optionsCity, setOptionsCity] = useState<SelectOption[]>([]);
  const [optionsCityCopy, setOptionsCityCopy] = useState<SelectOption[]>([]);
  const [optionsAdviser, setOptionsAdviser] = useState<SelectOption[]>([]);
  const [optionsAdviserCopy, setOptionsAdviserCopy] = useState<SelectOption[]>(
    []
  );

  //Dates
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [visitDate, setVisitDate] = useState<string>("");

  //Textbox
  const [startTime, setStartTime] = useState<string | moment.Moment | null>(
    null
  );
  const [endTime, setEndTime] = useState<string | moment.Moment | null>(null);

  //Checkbox
  const [checkboxMonday, setCheckboxMonday] = useState(false);
  const [checkboxTuesday, setCheckboxTuesday] = useState(false);
  const [checkboxWednesday, setCheckboxWednesday] = useState(false);
  const [checkboxThursday, setCheckboxThursday] = useState(false);
  const [checkboxFriday, setcheckboxFriday] = useState(false);
  const [checkboxSaturday, setCheckboxSaturday] = useState(false);
  const [checkboxSunday, setCheckboxSunday] = useState(false);

  //Mapa
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleMapKey!,
  });
  const [latitud, setLatitud] = useState(4.6534649);
  const [longitud, setLongitud] = useState(-74.0836453);

  //Shows
  const [showModalAddAgenda, setShowModalAddAgenda] = useState(false);
  const [showModalDeleteAgenda, setShowModalDeleteAgenda] = useState(false);
  const [showModalEditAgendaPermanent, setShowModalEditAgendaPermanent] =
    useState(false);
  const [showModalEditAgendaVisit, setShowModalEditAgendaVisit] =
    useState(false);

  //Create, update and delete message
  const [openMessageError, setOpenMessageError] = useState(false);
  const [openMessageCreatedAgenda, setOpenMessageCreatedAgenda] =
    useState(false);
  const [openMessageExistingAgenda, setOpenMessageExistingAgenda] =
    useState(false);
  const [openMessageUpdateAgenda, setOpenMessageUpdateAgenda] = useState(false);
  const [openMessageExpiredAgenda, setOpenMessageExpiredAgenda] =
    useState(false);
  const [openMessageDeleteAgenda, setOpenMessageDeleteAgenda] = useState(false);
  const [
    openMessageToDeleteAgendaWithCheckIn,
    setOpenMessageToDeleteAgendaWithCheckIn,
  ] = useState(false);
  const [openMessageStartDateError, setOpenMessageStartDateError] =
    useState(false);

  const [formCreateAppoiment, setFormCreateAppoiment] = useState({
    UserID: 0,
    PosCode: "",
    DateStart: "",
    DateEnd: "",
    DateVisit: "",
    AssignHourIn: "",
    AssignHourOut: "",
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
    AppointmentTypeID: 0,
  });

  const theme = createTheme({
    palette: {
      primary: {
        main: "#027aae",
      },
    },
  });

  useEffect(() => {
    getStateByCountry(Number(decryptText(state.user.countryId)));
    setDisableAdvisor(false);
    getAdvisorsBySupervisors(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageID]);

  useEffect(() => {
    if (!appointmentSelected) {
      setSubRetail([]);
      setPointOfSale([]);
      setStartTime(null);
      setEndTime(null);
      setStartDate("");
      setEndDate("");
      setVisitDate("");
      setCheckboxMonday(false);
      setCheckboxTuesday(false);
      setCheckboxWednesday(false);
      setCheckboxThursday(false);
      setcheckboxFriday(false);
      setCheckboxSaturday(false);
      setCheckboxSunday(false);
      setErrorDatePicker(false);
      setErrorPos(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeOfVisit]);

  useEffect(() => {
    if (subRetail.length > 0 && pointOfSale.length > 0) {
      getPosCoordinates();
    } else {
      setAddAgendaButtonDisable(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subRetail, pointOfSale]);

  const ValidateCoordinates = (
    posCoordinates: Array<IPointOfSaleByCoordinatesDto>
  ) => {
    let posWithouthCoordinate = posCoordinates.some(function (pos) {
      return pos.latitude === null || pos.longitude === null;
    });
    return posWithouthCoordinate;
  };

  const getPosCoordinates = () => {
    appointmentService.getPosCoordinates(String(pointOfSale)).then((r) => {
      let isNotValid = ValidateCoordinates(r);
      if (isNotValid) {
        setErrorPos(true);
        alert(t("header.errorPos"));
        setAddAgendaButtonDisable(true);
      } else {
        setErrorPos(false);
        setIsValidCoordinates(true);
      }
    });
  };

  useEffect(() => {
    if (Number(typeOfVisit) === 2 || Number(typeOfVisit) === 7) {
      if (
        isValidCoordinates === true &&
        visitDate !== "" &&
        startTime !== null &&
        endTime !== null
      ) {
        setAddAgendaButtonDisable(false);
      } else {
        setAddAgendaButtonDisable(true);
      }
    } else {
      if (
        isValidCoordinates === true &&
        startDate !== "" &&
        endDate !== "" &&
        startTime !== null &&
        endTime !== null
      ) {
        if (
          checkboxMonday === true ||
          checkboxTuesday === true ||
          checkboxWednesday === true ||
          checkboxThursday === true ||
          checkboxFriday === true ||
          checkboxSaturday === true ||
          checkboxSunday === true
        ) {
          setAddAgendaButtonDisable(false);
        } else {
          setAddAgendaButtonDisable(true);
        }
      } else {
        setAddAgendaButtonDisable(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    startDate,
    endDate,
    visitDate,
    startTime,
    endTime,
    checkboxMonday,
    checkboxTuesday,
    checkboxWednesday,
    checkboxThursday,
    checkboxFriday,
    checkboxSaturday,
    checkboxSunday,
  ]);

  //Peticiones
  const getTypeOfAppointmentListByRoleType = () => {
    appointmentService
      .getTypeOfAppointmentListByRoleType(2, languageID.value)
      .then((r: any) => {
        fillDataTypeOfAppointment(r);
      })
      .finally(() => {
        if (typeofAppointmentData) {
          setDisableTypeOfVisit(false);
        } else {
          //MESSAGE NO CHARGE
        }
      });
  };

  const getSubretail = () => {
    appointmentService
      .getSubretailList()
      .then((r: any) => {
        fillDataSubretail(r);
      })
      .finally(() => {
        if (subretailData) {
          setDisableSubretail(false);
        } else {
          //MESSAGE NO CHARGE
        }
      });
  };

  const getPointOfsale = (subretailId: number) => {
    appointmentService
      .getPosListBySubretailList(String(subretailId))
      .then((r: any) => {
        fillDataPointOfSale(r);
      })
      .finally(() => {
        if (pointOfSaleData) {
          setDisablePointOfSale(false);
        } else {
          //MESSAGE NO CHARGE
        }
      });
  };

  const getPointOfsaleByList = (values: string) => {
    appointmentService
      .getPosListBySubretailList(values)
      .then((r: any) => {
        fillDataPointOfSaleByList(r);
      })
      .finally(() => {
        if (pointOfSaleData) {
          setDisablePointOfSale(false);
        } else {
          //MESSAGE NO CHARGE
        }
      });
  };

  const getStateByCountry = (countryID: number) => {
    AgendaManagement.getStateByCountry(countryID).then(
      (result: IGetStateListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.stateID,
          label: item.stateName,
        }));
        setOptionsState(updatedOptions);
        setOptionsStateCopy(updatedOptions);
      }
    );
  };

  const getCityByState = (stateID: number) => {
    AgendaManagement.getCityByState(stateID).then(
      (result: IGetCityListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.cityID,
          label: item.cityName,
        }));
        setOptionsCity(updatedOptions);
        setOptionsCityCopy(updatedOptions);
      }
    );
  };

  const getAdvisorsBySupervisors = (cityID: number) => {
    AgendaManagement.getAdvisorsBySupervisors(cityID).then(
      (result: IGetAdviserListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.userID,
          label: item.userName + " " + item.lastName,
        }));
        setOptionsAdviser(updatedOptions);
        setOptionsAdviserCopy(updatedOptions);
      }
    );
  };

  const getAppointmentsByUser = (userID: number, languageID: number) => {
    AgendaManagement.getAppointmentsByUser(userID, languageID).then(
      (result: IGetAppointmentsByUser[]) => {
        tableDataArray = result;
        if (tableDataArray.length > 0) {
          getTypeOfAppointmentListByRoleType();
        }
        setLatitud(result[0]?.latitude);
        setLongitud(result[0]?.longitude);

        fillData(result);
      }
    );
  };

  const handleActionRowConfig = (
    e: React.SyntheticEvent,
    option?: OptionInterface
  ) => {
    if (option) {
      setAppointmentSelected(Number(option.value));
      if (
        option.label === "Edit" ||
        option.label === "Editar" ||
        option.label === "Editar"
      ) {
        let item = tableDataArray.find(
          (x) => x.appointmentID === Number(option.value)
        );
        ChargeInfoForEdit(Number(option.value));
        if (item?.appointmentTypeID === 1) {
          setShowModalEditAgendaPermanent(true);
        } else if (item?.appointmentTypeID === 2 || item?.appointmentTypeID === 7) {
          setShowModalEditAgendaVisit(true);
        } else if (item?.appointmentTypeID === 3) {
          setShowModalEditAgendaPermanent(true);
        }
      } else if (
        option.label === "Delete" ||
        option.label === "Eliminar" ||
        option.label === "Excluir"
      ) {
        setShowModalDeleteAgenda(true);
      }
    }
  };

  const ChargeInfoForEdit = (appointmentId: number) => {
    let item = tableDataArray.find((x) => x.appointmentID === appointmentId);

    if (item) {
      setTypeOfVisit([item.appointmentTypeID]);
      setTypeOfVisitId(item.appointmentTypeID);
      getSubretail();
      getPointOfsale(item.subretailID);
      const hourIn = item.assignHourIn; 
      const hourOut = item.assignHourOut; 

      if (item.appointmentTypeID === 2) {
        setSubRetail([item.subretailID]);
        setPointOfSale([item.posCode]);
        setStartTime(moment.utc(`2023-01-19T${hourIn}:00`));
        setEndTime(moment.utc(`2023-01-19T${hourOut}:00`));
        setStartDate(item.dateStart);
        setEndDate(item.dateStart);
        setVisitDate(item.dateStart);
      } else {
        setSubRetail([item.subretailID]);
        setPointOfSale([item.posCode]);
        setStartTime(moment.utc(`2023-01-19T${hourIn}:00`));
        setEndTime(moment.utc(`2023-01-19T${hourOut}:00`));
        setStartDate(item.dateStart);
        setEndDate(item.dateEnd);
        setVisitDate(item.dateStart);
        setCheckboxMonday(item.monday);
        setCheckboxTuesday(item.tuesday);
        setCheckboxWednesday(item.wednesday);
        setCheckboxThursday(item.thursday);
        setcheckboxFriday(item.friday);
        setCheckboxSaturday(item.saturday);
        setCheckboxSunday(item.sunday);
      }
    }
  };

  const FormatDate = (date: string) => {
    let timestamp = Date.parse(date);
    if (!isNaN(timestamp)) {
      let dateTemp = new Date(date);
      let year = dateTemp.getFullYear();
      let month = (dateTemp.getMonth() + 1).toString().padStart(2, "0");
      let day = dateTemp.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    } else {
      return "";
    }
  };

  const fillData = (data: IGetAppointmentsByUser[]) => {
    const pagedData: TableData[] = [];

    for (let i = 0; i < data.length; i++) {
      const agenda: IGetAppointmentsByUser = data[i];
      let tableData: TableData = {};
      tableData = {
        appointmentId: agenda.appointmentID,
        subretail: agenda.subretailName,
        subretailId: agenda.subretailID,
        posCode: agenda.posCode,
        pos: agenda.pointOfSale,
        typeAppointment: agenda.appointmentType,
        typeAppointmentId: agenda.appointmentTypeID,
        startDate: FormatDate(agenda.dateStart),
        endDate: FormatDate(agenda.dateEnd),
        assignHourIn: agenda.assignHourIn,
        assignHourOut: agenda.assignHourOut,
        monday: agenda.monday,
        tuesday: agenda.tuesday,
        wednesday: agenda.wednesday,
        thursday: agenda.thursday,
        friday: agenda.friday,
        saturday: agenda.saturday,
        sunday: agenda.sunday,
        latitude: agenda.latitude,
        longitude: agenda.longitude,
        rowConfig: {
          action: (
            <ContextualMenu
              onClick={handleActionRowConfig}
              options={[
                {
                  value: agenda.appointmentID,
                  label: t("header.edit"),
                  icon: <IconPencil />,
                },
                {
                  value: agenda.appointmentID,
                  label: t("header.delete"),
                  icon: <IconTrash />,
                },
              ]}
              placement="leading"
            />
          ),
          disabled: false,
          noWrap: false,
          selected: false,
        },
      };
      pagedData.push(tableData);
    }
    setTableData(pagedData);
    setTableFilteredData(pagedData);
  };

  const fillDataTypeOfAppointment = (data: ITypeOfAppointmentDto[]) => {
    const typeOfAppointmentData: SelectOption[] = [];

    for (let i = 0; i < data.length; i++) {
      const typeOfAppointment: ITypeOfAppointmentDto = data[i];
      let selectTypeOfAppointmentData: SelectOption;
      if (typeOfAppointment.fieldID !== 0) {
        selectTypeOfAppointmentData = {
          value: typeOfAppointment.fieldID,
          label: typeOfAppointment.fieldValue,
        };
        typeOfAppointmentData.push(selectTypeOfAppointmentData);
      }
    }
    setTypeofAppointmentData(typeOfAppointmentData);
    setTypeofAppointmentDataCopy(typeOfAppointmentData);
  };

  const fillDataSubretail = (data: ISubretailDto[]) => {
    const subretailData: SelectOption[] = [];

    for (let i = 0; i < data.length; i++) {
      const subretail: ISubretailDto = data[i];
      let selectSubretailData: SelectOption;
      if (subretail.fieldID !== 0) {
        selectSubretailData = {
          value: subretail.fieldID,
          label: subretail.fieldValue,
        };
        subretailData.push(selectSubretailData);
      }
    }
    setSubretailData(subretailData);
    setSubretailDataCopy(subretailData);
  };

  const fillDataPointOfSale = (data: IPointOfSaleByListDto[]) => {
    const pointOfsaleData: SelectOption[] = [];

    for (let i = 0; i < data.length; i++) {
      const pointOfsale: IPointOfSaleByListDto = data[i];
      let selectePointOfSaleData: SelectOption;
      if (pointOfsale.fieldID) {
        selectePointOfSaleData = {
          value: pointOfsale.fieldID,
          label: pointOfsale.fieldValue,
        };
        pointOfsaleData.push(selectePointOfSaleData);
      }
    }
    setPointOfSaleData(pointOfsaleData);
    setPointOfSaleDataCopy(pointOfsaleData);
  };

  const fillDataPointOfSaleByList = (data: IPointOfSaleByListDto[]) => {
    const pointOfsaleData: SelectOption[] = [];

    for (let i = 0; i < data.length; i++) {
      const pointOfsale: IPointOfSaleByListDto = data[i];
      let selectePointOfSaleData: SelectOption;
      if (pointOfsale.fieldID) {
        selectePointOfSaleData = {
          value: pointOfsale.fieldID,
          label: pointOfsale.fieldValue,
        };
        pointOfsaleData.push(selectePointOfSaleData);
      }
    }
    setPointOfSaleData(pointOfsaleData);
    setPointOfSaleDataCopy(pointOfsaleData);
  };

  const columns: TableColumns[] = [
    {
      id: "subretail",
      label: t("header.subRetail"),
      filter: (
        <div style={{ width: "80%" }}>
          <Search
            label={t("header.subRetail")}
            placeholder={`Buscar ${t("header.subRetail")}`}
            id={`table-filter`}
            onClear={() => {}}
            onChange={(e) => handleFilterChange("subretail", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "posCode",
      label: t("header.pointOfSaleCode"),
      filter: (
        <div style={{ width: "80%" }}>
          <Search
            label={t("header.pointOfSaleCode")}
            placeholder={`Buscar ${t("header.pointOfSaleCode")}`}
            id={`table-filter`}
            onClear={() => {}}
            onChange={(e) => handleFilterChange("posCode", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "pos",
      label: t("header.pointOfSale"),
      filter: (
        <div style={{ width: "80%" }}>
          <Search
            label={t("header.pointOfSale")}
            placeholder={`Buscar ${t("header.pointOfSale")}`}
            id={`table-filter`}
            onClear={() => {}}
            onChange={(e) => handleFilterChange("pos", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "typeAppointment",
      label: t("header.typeOfVisit"),
      filter: (
        <div style={{ width: "80%" }}>
          <Search
            label={t("header.typeOfVisit")}
            placeholder={`Buscar ${t("header.typeOfVisit")}`}
            id={`table-filter`}
            onClear={() => {}}
            onChange={(e) =>
              handleFilterChange("typeAppointment", e!.toString())
            }
          />
        </div>
      ),
    },
    {
      id: "startDate",
      label: t("header.stardDate"),
      filter: (
        <div style={{ width: "80%" }}>
          <Search
            label={t("header.stardDate")}
            placeholder={`Buscar ${t("header.stardDate")}`}
            id={`table-filter`}
            onClear={() => {}}
            onChange={(e) => handleFilterChange("startDat", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "endDate",
      label: t("header.endDate"),
      filter: (
        <div style={{ width: "80%" }}>
          <Search
            label={t("header.endDate")}
            placeholder={`Buscar ${t("header.endDate")}`}
            id={`table-filter`}
            onClear={() => {}}
            onChange={(e) => handleFilterChange("endDate", e!.toString())}
          />
        </div>
      ),
    },
    {
      id: "assignHourIn",
      label: t("header.startTime"),
    },
    {
      id: "assignHourOut",
      label: t("header.endTime"),
    },
  ];

  const handleFilterChange = (field: keyof any, value: string) => {
    const lowerCaseValue = value.toLowerCase();
    const filterArray = tableFilteredData.filter((element: any) => {
      const elementValue = element[field]?.toString().toLowerCase() || "";
      return elementValue.includes(lowerCaseValue);
    });

    setTableData(filterArray);
  };

  const columnsWidth: TableColumnWidth[] = [
    {
      columnId: "subretail",
    },
    {
      columnId: "posCode",
    },
    {
      columnId: "pos",
    },
    {
      columnId: "typeAppointment",
    },
    {
      columnId: "startDate",
    },
    {
      columnId: "endDate",
    },
    {
      columnId: "assignHourIn",
    },
    {
      columnId: "assignHourOut",
    },
  ];

  const tablePreferences: TablePreferences = {
    width: columnsWidth,
  };

  const ResetFormAgenda = () => {
    setTypeOfVisit([]);
    setTypeOfVisitId(NaN);
    setSubRetail([]);
    setPointOfSale([]);
    setStartTime(null);
    setEndTime(null);
    setStartDate("");
    setEndDate("");
    setVisitDate("");
    setCheckboxMonday(false);
    setCheckboxTuesday(false);
    setCheckboxWednesday(false);
    setCheckboxThursday(false);
    setcheckboxFriday(false);
    setCheckboxSaturday(false);
    setCheckboxSunday(false);
    setErrorDatePicker(false);
    setErrorPos(false);
  };

  const onClearAdvisorSelect = () => {
    setTableData([]);
    setTableFilteredData([]);
    setValueAdviser([]);
    setOpenAddAgendaDisable(true);
  };

  const onClearStateSelect = () => {
    setTableData([]);
    setTableFilteredData([]);
    setValueState([]);
    setValueCity([]);
    setValueAdviser([]);
    getAdvisorsBySupervisors(0);
    setIsStateValid(true);
    setDisableAdvisor(false);
  };

  const onClearCitySelect = () => {
    setTableData([]);
    setTableFilteredData([]);
    setValueCity([]);
    setValueAdviser([]);
    setOptionsAdviser([]);
  };

  const onChangeState = (selectedOption: SelectOption) => {
    setValueState([Number(selectedOption.value)]);
    getCityByState(Number(selectedOption.value));
    setOptionsAdviser([]);
    setValueCity([]);
    setValueAdviser([]);
    setDisableAdvisor(true);

    if (selectedOption) {
      setIsStateValid(false);
    }
  };

  const onChangeCity = (selectedOption: SelectOption) => {
    setValueCity([Number(selectedOption.value)]);
    getAdvisorsBySupervisors(Number(selectedOption.value));

    if (selectedOption) {
      setDisableAdvisor(false);
    }
  };

  const onChangeAdviser = (selectedOption: SelectOption) => {
    setValueAdviser([Number(selectedOption.value)]);
    if (selectedOption.value !== undefined) {
      setOpenAddAgendaDisable(false);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        UserID: Number(selectedOption.value),
      });
    }

    getAppointmentsByUser(Number(selectedOption.value), languageID.value);
  };

  const submitAddAgenda = () => {
    AgendaManagement.postCreateAppointment(formCreateAppoiment).then((r) => {
      switch (r) {
        case 0: {
          setOpenMessageError(true);
          break;
        }
        case 1: {
          setShowModalAddAgenda(false);
          ResetFormAgenda();
          setOpenMessageCreatedAgenda(true);
          getAppointmentsByUser(Number(valueAdviser), languageID.value);
          break;
        }
        case 2: {
          setOpenMessageExistingAgenda(true);
          break;
        }
        default: {
          setOpenMessageError(true);
        }
      }
    });
  };

  const cancelAddAgenda = () => {
    setShowModalAddAgenda(false);
    setErrorPos(false);
    setIsValidCoordinates(false);
    ResetFormAgenda();
  };

  const getDayOfWeek = (dateString: string): string => {
    const date = new Date(dateString);
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return daysOfWeek[date.getUTCDay()];
  };

  const submitEditAgenda = () => {
    let item = tableData.find((x) => x.appointmentId === appointmentSelected);
    const today = new Date();

    const dayOfWeek = getDayOfWeek(String(visitDate));

    let appointmentUpdateIn: IUpdateAppoiment = {
      AppointmentID: appointmentSelected,
      DateStart:
        item?.typeAppointmentId === 2
          ? FormatDate(String(visitDate))
          : FormatDate(String(startDate)),
      DateEnd:
        item?.typeAppointmentId === 2
          ? FormatDate(String(visitDate))
          : FormatDate(String(endDate)),
      DateVisit:
        item?.typeAppointmentId === 2
          ? FormatDate(String(visitDate))
          : FormatDate(String(startDate)),
      AssignHourIn: moment.utc(String(startTime)).format("H:mm"),
      AssignHourOut: moment.utc(String(endTime)).format("H:mm"),
      Monday:
        item?.typeAppointmentId === 2 ? dayOfWeek === "Monday" : checkboxMonday,
      Tuesday:
        item?.typeAppointmentId === 2
          ? dayOfWeek === "Tuesday"
          : checkboxTuesday,
      Wednesday:
        item?.typeAppointmentId === 2
          ? dayOfWeek === "Wednesday"
          : checkboxWednesday,
      Thursday:
        item?.typeAppointmentId === 2
          ? dayOfWeek === "Thursday"
          : checkboxThursday,
      Friday:
        item?.typeAppointmentId === 2 ? dayOfWeek === "Friday" : checkboxFriday,
      Saturday:
        item?.typeAppointmentId === 2
          ? dayOfWeek === "Saturday"
          : checkboxSaturday,
      Sunday:
        item?.typeAppointmentId === 2 ? dayOfWeek === "Sunday" : checkboxSunday,
      UserID: Number(valueAdviser),
    };

    if (item?.startDate !== FormatDate(String(startDate))) {
      if (item?.startDate <= FormatDate(String(today))) {
        setErrorDatePicker(true);
        setOpenMessageStartDateError(true);
      } else {
        AgendaManagement.postUpdateAppointment(appointmentUpdateIn).then(
          (r) => {
            switch (r) {
              case 0: {
                setOpenMessageError(true);
                break;
              }
              case 1: {
                setShowModalEditAgendaPermanent(false);
                setShowModalEditAgendaVisit(false);
                ResetFormAgenda();
                setAppointmentSelected(NaN);
                setOpenMessageUpdateAgenda(true);
                getAppointmentsByUser(Number(valueAdviser), languageID.value);
                break;
              }
              case 2: {
                setOpenMessageExistingAgenda(true);
                break;
              }
              case 3: {
                setOpenMessageExpiredAgenda(true);
                break;
              }
              default: {
                setOpenMessageError(true);
              }
            }
          }
        );
      }
    } else {
      AgendaManagement.postUpdateAppointment(appointmentUpdateIn)
        .then((r) => {
          switch (r) {
            case 0: {
              setOpenMessageError(true);
              break;
            }
            case 1: {
              setShowModalEditAgendaPermanent(false);
              setShowModalEditAgendaVisit(false);
              setAppointmentSelected(NaN);
              setOpenMessageUpdateAgenda(true);
              getAppointmentsByUser(Number(valueAdviser), languageID.value);
              break;
            }
            case 2: {
              setOpenMessageExistingAgenda(true);
              break;
            }
            case 3: {
              setOpenMessageExpiredAgenda(true);
              break;
            }
            default: {
              setOpenMessageError(true);
            }
          }
        })
        .finally(() => {
          ResetFormAgenda();
        });
    }
  };

  const cancelEditAgendaPermanent = () => {
    setShowModalEditAgendaPermanent(false);
    setErrorDatePicker(false);
    setIsValidCoordinates(false);
    setAppointmentSelected(NaN);
    ResetFormAgenda();
  };

  const cancelEditAgendaVisit = () => {
    setShowModalEditAgendaVisit(false);
    setIsValidCoordinates(false);
    setAppointmentSelected(NaN);
    ResetFormAgenda();
  };

  const handleChangeTypeOfVisit = (value: SelectValue) => {
    setTypeOfVisit([value]);
    setTypeOfVisitId(Number(value));
    getSubretail();
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      AppointmentTypeID: Number(value),
    });
  };

  const onClearTypeOfVisit = () => {
    ResetFormAgenda();
    setDisablePointOfSale(true);
  };

  const handleChangeSubRetail = (value: SelectValue) => {
    setSubRetail([value]);
    getPointOfsale(parseInt(value.toString()));
  };

  const handleChangePointOfSale = (value: SelectValue) => {
    setPointOfSale([value]);
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      PosCode: value.toString(),
    });
  };

  const onClearSubRetail = () => {
    setSubRetail([]);
    setPointOfSale([]);
    setDisablePointOfSale(true);
  };

  const handleChangeSubRetailList = (value: SelectValue) => {
    const valueCopy = [...subRetail];
    const isOptionSelected = valueCopy.includes(value);

    if (isOptionSelected) {
      const index = valueCopy.indexOf(value);
      valueCopy.splice(index, 1);
    } else {
      valueCopy.push(value);
    }
    setSubRetail(valueCopy);

    getPointOfsaleByList(String(valueCopy));
  };

  const handleChangePointOfSaleList = (value: SelectValue) => {
    const valueCopy = [...pointOfSale];

    const isOptionSelected = valueCopy.includes(value);
    if (isOptionSelected) {
      const index = valueCopy.indexOf(value);
      valueCopy.splice(index, 1);
    } else {
      valueCopy.push(value);
    }
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      PosCode: valueCopy.join(", "),
    });
    setPointOfSale(valueCopy);
  };

  const deleteAgenda = () => {
    AgendaManagement.deleteAppointment(appointmentSelected).then((r) => {
      switch (r) {
        case 0: {
          setOpenMessageError(true);
          break;
        }
        case 1: {
          setTableData([]);
          setTableFilteredData([]);
          setShowModalDeleteAgenda(false);
          setAppointmentSelected(NaN);
          setOpenMessageDeleteAgenda(true);
          getAppointmentsByUser(Number(valueAdviser), languageID.value);
          break;
        }
        case 2: {
          setOpenMessageToDeleteAgendaWithCheckIn(true);
          break;
        }
        case 3: {
          setOpenMessageExpiredAgenda(true);
          break;
        }
        default: {
          setOpenMessageError(true);
        }
      }
    });
  };

  const cancelDeleteAgenda = () => {
    setShowModalDeleteAgenda(false);
  };

  const openModalAddAgenda = () => {
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      PosCode: "",
      DateStart: "",
      DateEnd: "",
      DateVisit: "",
      AssignHourIn: "",
      AssignHourOut: "",
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
      AppointmentTypeID: 0,
    });
    setShowModalAddAgenda(true);
    getTypeOfAppointmentListByRoleType();
  };

  const handleChangeStartDate = (date: DateRange) => {
    if (date.startDate === undefined && date.endDate === undefined) {
      setVisitDate(String(date));
      const dayOfWeek = getDayOfWeek(String(date));
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        DateVisit: FormatDate(String(date)),
        DateStart: FormatDate(String(date)),
        DateEnd: FormatDate(String(date)),
        Monday: dayOfWeek === "Monday",
        Tuesday: dayOfWeek === "Tuesday",
        Wednesday: dayOfWeek === "Wednesday",
        Thursday: dayOfWeek === "Thursday",
        Friday: dayOfWeek === "Friday",
        Saturday: dayOfWeek === "Saturday",
        Sunday: dayOfWeek === "Sunday",
      });
    } else {
      setStartDate(String(date.startDate));
      setEndDate(String(date.endDate));

      setFormCreateAppoiment({
        ...formCreateAppoiment,
        DateVisit: FormatDate(String(date.startDate)),
        DateStart: FormatDate(String(date.startDate)),
        DateEnd: FormatDate(String(date.endDate)),
      });
    }
  };

  const handleChangeVisitDate = (date: DateRange) => {
    setVisitDate(String(date));
  };

  const handleStartTimeChange = (newStartTime: any) => {
    setStartTime(newStartTime);
    if (
      endTime &&
      newStartTime &&
      moment(newStartTime).isAfter(moment(endTime))
    ) {
      setEndTime(newStartTime);
    }
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      AssignHourIn: moment(String(newStartTime)).format("H:mm"),
    });
  };

  const handleEndTimeChange = (newEndTime: any) => {
    if (
      startTime &&
      newEndTime &&
      moment(newEndTime).isBefore(moment(startTime))
    ) {
      return;
    }
    setEndTime(newEndTime);
    setFormCreateAppoiment({
      ...formCreateAppoiment,
      AssignHourOut: moment(String(newEndTime)).format("H:mm"),
    });
  };

  const onChangeCheckboxCreateAgenda = (day: number) => {
    if (day === 1) {
      setCheckboxMonday(!checkboxMonday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Monday: !checkboxMonday,
      });
    } else if (day === 2) {
      setCheckboxTuesday(!checkboxTuesday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Tuesday: !checkboxTuesday,
      });
    } else if (day === 3) {
      setCheckboxWednesday(!checkboxWednesday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Wednesday: !checkboxWednesday,
      });
    } else if (day === 4) {
      setCheckboxThursday(!checkboxThursday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Thursday: !checkboxThursday,
      });
    } else if (day === 5) {
      setcheckboxFriday(!checkboxFriday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Friday: !checkboxFriday,
      });
    } else if (day === 6) {
      setCheckboxSaturday(!checkboxSaturday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Saturday: !checkboxSaturday,
      });
    } else if (day === 7) {
      setCheckboxSunday(!checkboxSunday);
      setFormCreateAppoiment({
        ...formCreateAppoiment,
        Sunday: !checkboxSunday,
      });
    }
  };

  return (
    <div className="generalAgendaDiv">
      <div className="topElements">
        <div className="divTitle">
          <h4 className="title">{t("header.schedulingAgendas")}</h4>
          <div className="divTittleSelects">
            <Select
              className="selectGeneralAgenda"
              options={optionsState}
              id="selectState"
              label={t("header.state")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeState}
              value={valueState}
              onClear={onClearStateSelect}
              onSearch={(query: string) =>
                handleSearch(query, optionsStateCopy, setOptionsState)
              }
              searchDelay={500}
              showSearch={true}
            />
            <Select
              className="selectGeneralAgenda"
              options={optionsCity}
              id="selectCity"
              label={t("header.city")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeCity}
              value={valueCity}
              disabled={isStateValid}
              onClear={onClearCitySelect}
              onSearch={(query: string) =>
                handleSearch(query, optionsCityCopy, setOptionsCity)
              }
              searchDelay={500}
              showSearch={true}
            />
            <Select
              className="selectGeneralAgenda"
              options={optionsAdviser}
              id="selectAdviser"
              label={t("header.adviser")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeAdviser}
              value={valueAdviser}
              disabled={disableAdvisor}
              onClear={onClearAdvisorSelect}
              onSearch={(query: string) =>
                handleSearch(query, optionsAdviserCopy, setOptionsAdviser)
              }
              searchDelay={500}
              showSearch={true}
            />

            <Button
              className="buttonAddAgenda"
              leadingIcon={<IconDocumentCopy />}
              disabled={openAddAgendaDisable}
              onClick={openModalAddAgenda}
            >
              {t("header.addAgenda")}
            </Button>
          </div>
        </div>
        <div className="divMap">
          {isLoaded ? (
            <GoogleMap
              zoom={12}
              center={{ lat: latitud ?? 0, lng: longitud ?? 0 }}
              mapContainerClassName="map-container"
            >
              {tableData ? (
                tableData.map((x) => {
                  return (
                    <Marker
                      position={{ lat: x.latitude ?? 0, lng: x.longitude ?? 0 }}
                    ></Marker>
                  );
                })
              ) : (
                <div></div>
              )}
            </GoogleMap>
          ) : (
            <div></div>
          )}
        </div>
        <div className="stepper">
          {tableData ? (
            <Stepper
              direction="vertical"
              className="stepperComponent"
              customStyle={"stepperComponent"}
              steps={tableData.map((x, index) => {
                return {
                  label: `${x.pos}`,
                  status: "current",
                  step: `${index + 1}`,
                };
              })}
            />
          ) : (
            <div></div>
          )}
        </div>
      </div>

      <Card
        appearance="outlined"
        className="divTable"
        content={
          <Table
            className="table"
            behavior={{
              type: "singlePage",
            }}
            columnResize
            preferences={tablePreferences}
            loading={loadingTableData}
            columns={columns}
            data={tableData}
            loadingDataLength={10}
            customNoItems={
              <div className="customNoItems">
                <div className="DivIconCustomNoItems">
                  <IconWarningAlt className="IconCustomNoItems" />
                </div>
                {t("header.noItemsFound")}
              </div>
            }
            showFilters={tableFilteredData.length > 0}
          />
        }
      />

      {/* //Modal add agenda */}
      <div style={{ position: "relative" }}>
        <Modal
          className="modalAddAgenda"
          closeButton={true}
          align="center"
          id="modalAddAgenda"
          show={showModalAddAgenda}
          onClose={cancelAddAgenda}
          footer={
            <ButtonGroup className="createAgendaButtongrouop">
              <Button
                disabled={addAgendaButtonDisable}
                onClick={submitAddAgenda}
              >
                {t("header.submit")}
              </Button>
              <Button onClick={cancelAddAgenda} appearance="secondary">
                {t("header.cancel")}
              </Button>
            </ButtonGroup>
          }
          title={t("header.addAgenda")}
        >
          <div className="createAgenda">
            <Select
              className="createAgendaSelect"
              label={t("header.typeOfVisit")}
              onChange={(e) => handleChangeTypeOfVisit(e.value)}
              options={typeofAppointmentData}
              value={typeOfVisit}
              onClear={() => onClearTypeOfVisit()}
              disabled={disableTypeOfVisit}
              onSearch={(query: string) =>
                handleSearch(
                  query,
                  typeofAppointmentDataCopy,
                  setTypeofAppointmentData
                )
              }
              searchDelay={500}
              showSearch={true}
            />

            <AgendaCreationBlock
              typeOfVisitID={typeOfVisitId}
              labelSubretail={t("header.subRetail")}
              handleChangeSubRetail={handleChangeSubRetail}
              subretailData={subretailData}
              subRetail={subRetail}
              onClearSubRetail={onClearSubRetail}
              disableSubretail={disableSubretail}
              labelPointOfSale={t("header.pointOfSale")}
              handleChangePointOfSale={handleChangePointOfSale}
              pointOfSaleData={pointOfSaleData}
              pointOfSale={pointOfSale}
              setPointOfSale={setPointOfSale}
              disablePointOfSale={disablePointOfSale}
              errorPos={errorPos}
              endDate={endDate}
              handleChangeStartDate={handleChangeStartDate}
              startDate={startDate}
              errorDatePicker={errorDatePicker}
              theme={theme}
              labelStartTime={t("header.startTime")}
              startTime={startTime}
              handleChangeStartTime={handleStartTimeChange}
              labelEndTime={t("header.endTime")}
              endTime={endTime}
              labelStardDate={t("header.stardDate")}
              labelEndDate={t("header.endDate")}
              handleChangeEndTime={handleEndTimeChange}
              labelMonday={t("header.monday")}
              checkboxMonday={checkboxMonday}
              onChangeCheckboxCreateAgenda={onChangeCheckboxCreateAgenda}
              labelTuesday={t("header.tuesday")}
              checkboxTuesday={checkboxTuesday}
              labelWednesday={t("header.wednesday")}
              checkboxWednesday={checkboxWednesday}
              labelThursday={t("header.thursday")}
              checkboxThursday={checkboxThursday}
              labelFriday={t("header.friday")}
              checkboxFriday={checkboxFriday}
              labelSaturday={t("header.saturday")}
              checkboxSaturday={checkboxSaturday}
              labelSunday={t("header.sunday")}
              checkboxSunday={checkboxSunday}
              labelVisitDate={t("header.visitDate")}
              visitDate={visitDate}
              handleChangePointOfSaleList={handleChangePointOfSaleList}
              handleChangeSubRetailList={handleChangeSubRetailList}
              subretailDataCopy={subretailDataCopy}
              setSubretailData={setSubretailData}
              pointOfSaleDataCopy={pointOfSaleDataCopy}
              setPointOfSaleData={setPointOfSaleData}
            />
          </div>
        </Modal>
      </div>

      {/* Modal delete agenda */}
      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          id="modalDeleteAgenda"
          show={showModalDeleteAgenda}
          onClose={() => setShowModalDeleteAgenda(false)}
          footer={
            <ButtonGroup className="deleteAgendaButtongrouop">
              <Button onClick={deleteAgenda}>{t("header.yes")}</Button>
              <Button onClick={cancelDeleteAgenda} appearance="secondary">
                {t("header.cancel")}
              </Button>
            </ButtonGroup>
          }
          title={t("modal.titleDeleteAgenda")}
        >
          <IconTrash size={150} />
          <p>{t("modal.questionDeleteAgenda")}</p>
        </Modal>
      </div>

      {/* Modal Editar agenda*/}
      <div style={{ position: "relative" }}>
        <AgendaEditingBLock
          showModalEditAgendaPermanent={showModalEditAgendaPermanent}
          cancelEditAgendaPermanent={cancelEditAgendaPermanent}
          editAgendaButtonDisable={editAgendaButtonDisable}
          submitEditAgenda={submitEditAgenda}
          handleChangeTypeOfVisit={handleChangeTypeOfVisit}
          typeofAppointmentData={typeofAppointmentData}
          typeOfVisit={typeOfVisit}
          onClearTypeOfVisit={onClearTypeOfVisit}
          handleChangeSubRetail={handleChangeSubRetail}
          subretailData={subretailData}
          subRetail={subRetail}
          onClearSubRetail={onClearSubRetail}
          setPointOfSale={setPointOfSale}
          pointOfSaleData={pointOfSaleData}
          pointOfSale={pointOfSale}
          errorPos={errorPos}
          endDate={endDate}
          handleChangeStartDate={handleChangeStartDate}
          startDate={startDate}
          errorDatePicker={errorDatePicker}
          startTime={startTime}
          setStartTime={setStartTime}
          endTime={endTime}
          setEndTime={setEndTime}
          checkboxMonday={checkboxMonday}
          setCheckboxMonday={setCheckboxMonday}
          checkboxTuesday={checkboxTuesday}
          setCheckboxTuesday={setCheckboxTuesday}
          checkboxWednesday={checkboxWednesday}
          setCheckboxWednesday={setCheckboxWednesday}
          checkboxThursday={checkboxThursday}
          setCheckboxThursday={setCheckboxThursday}
          checkboxFriday={checkboxFriday}
          setcheckboxFriday={setcheckboxFriday}
          checkboxSaturday={checkboxSaturday}
          setCheckboxSaturday={setCheckboxSaturday}
          checkboxSunday={checkboxSunday}
          setCheckboxSunday={setCheckboxSunday}
          showModalEditAgendaVisit={showModalEditAgendaVisit}
          cancelEditAgendaVisit={cancelEditAgendaVisit}
          handleChangeVisitDate={handleChangeVisitDate}
          visitDate={visitDate}
        />
      </div>

      {/* Modal Messages*/}
      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openMessageCreatedAgenda}
          closeModal={setOpenMessageCreatedAgenda}
          title={t("modal.message")}
          message={t("modal.agendaCreated")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openMessageError}
          closeModal={setOpenMessageError}
          title={t("modal.message")}
          message={t("modal.generalError")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openMessageExistingAgenda}
          closeModal={setOpenMessageExistingAgenda}
          title={t("modal.message")}
          message={t("modal.existingAgenda")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openMessageUpdateAgenda}
          closeModal={setOpenMessageUpdateAgenda}
          title={t("modal.message")}
          message={t("modal.updateInfo")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openMessageExpiredAgenda}
          closeModal={setOpenMessageExpiredAgenda}
          title={t("modal.message")}
          message={t("modal.expiredAgenda")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openMessageDeleteAgenda}
          closeModal={setOpenMessageDeleteAgenda}
          title={t("modal.message")}
          message={t("modal.deleteAgenda")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openMessageToDeleteAgendaWithCheckIn}
          closeModal={setOpenMessageToDeleteAgendaWithCheckIn}
          title={t("modal.message")}
          message={t("modal.deleteAgendaWithCheckIn")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openMessageStartDateError}
          closeModal={setOpenMessageStartDateError}
          title={t("modal.message")}
          message={t("header.errorstartDate")}
        />
      </div>
    </div>
  );
}
